import {
  ContentArea,
  Header,
  MenuManager,
  Panels,
  PlusButton,
} from '../components';

const Home = () => {
  return (
    <>
      <Panels />
      <MenuManager>
        <Header />
        <ContentArea />
        <PlusButton />
      </MenuManager>
    </>
  );
};

export default Home;
